import React, { useContext, useState } from 'react';
import { signInWithPopup } from 'firebase/auth';
import { auth, googleProvider } from '../../../config/firebase';
import { useHistory } from 'react-router-dom';
import { LayoutContext } from '../index';
import { useSnackbar } from 'notistack';
import axios from 'axios';

const GoogleAuth = ({ isSignup = false }) => {
  const { dispatch: layoutDispatch } = useContext(LayoutContext);
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);

  const apiURL = process.env.REACT_APP_API_URL;

  const handleGoogleSignIn = async () => {
    setLoading(true);
    try {
      // Sign in with Google popup
      const result = await signInWithPopup(auth, googleProvider);
      const user = result.user;

      // Get the ID token
      const idToken = await user.getIdToken();

      // Send token to backend for verification and user creation/login
      const response = await axios.post(`${apiURL}/api/auth/google`, {
        idToken,
        email: user.email,
        name: user.displayName,
        photoURL: user.photoURL,
      });

      if (response.data.token) {
        // Store JWT token
        localStorage.setItem('jwt', JSON.stringify(response.data));
        localStorage.setItem('userId', response.data.user._id);

        const message = isSignup 
          ? 'Inscription réussie avec Google !' 
          : 'Connexion réussie avec Google !';
        enqueueSnackbar(message, { variant: 'success' });

        // Close modal
        layoutDispatch({ type: 'loginSignupModalToggle', payload: false });

        // Redirect to home
        history.push('/');
      }
    } catch (error) {
      console.error('Google Sign-In Error:', error);
      enqueueSnackbar(
        error.response?.data?.error || 'Erreur lors de la connexion avec Google',
        { variant: 'error' }
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      onClick={handleGoogleSignIn}
      disabled={loading}
      type="button"
      className="w-full flex items-center justify-center gap-3 px-4 py-3 bg-white border-2 border-gray-300 rounded-lg hover:bg-gray-50 hover:border-blue-400 hover:shadow-md transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed group"
    >
      <svg className="w-5 h-5" viewBox="0 0 24 24">
        <path
          fill="#4285F4"
          d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
        />
        <path
          fill="#34A853"
          d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
        />
        <path
          fill="#FBBC05"
          d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
        />
        <path
          fill="#EA4335"
          d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
        />
      </svg>
      <span className="font-semibold text-gray-700 group-hover:text-gray-900">
        {loading ? 'Connexion...' : `${isSignup ? 'S\'inscrire' : 'Se connecter'} avec Google`}
      </span>
    </button>
  );
};

export default GoogleAuth;
